// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"5749dd8f","470":"8d28fa4b","713":"84555be7"}[chunkId] + ".chunk.js";
};